import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SFTypography from "../typography";
import { SFStack } from "../grid";
import useStyled from "../../hooks/useStyled";
import SFDrawer from "../drawer";
import SFAvatar from "../avatar";
import {
  SFLogoutIcon,
} from "../icons";
import { SFIconButton, SFButton } from "../buttons";
import { baseContainer } from "@base-provider";
import SFDialog from "../dialog";
import SFNotifications from "./notifications";

const { styled } = useStyled();

const SFAvatarStyled = styled(SFAvatar)(() => ({
  width: 35,
  height: 35,
  fontSize: 20,
}));

const StyledStack = styled(SFStack)(({ theme }) => ({
  width: "100%",
  marginTop: theme.spacing(2),
}));

const SFNotificationPanel = (props) => {
  const { t } = useTranslation();
  const [dialog, setDialog] = useState({
    open: false,
  });

  return (
    <>
      <SFDialog
        size={"sm"}
        open={dialog.open}
        header={
          <SFTypography variant="academyCardTitle">
            {dialog.header}
          </SFTypography>
        }
        onClose={() => setDialog({ open: false })}
        actionBtns={dialog.actionBtns}
      >
        {dialog.body}
      </SFDialog>

      <SFDrawer
        open={props.show}
        size={"m"}
        onClose={props.onClose}
        header={
          <SFStack
            justifyContent="flex-start"
            alignItems="center"
            direction="row"
            spacing={1}
          >
            <SFAvatarStyled src={props.avatar} />
            {props.name && (
              <SFTypography variant="cardSectionHeading">
                {props.name}
              </SFTypography>
            )}
            <SFIconButton
              variant="transparent"
              onClick={() =>
                setDialog({
                  open: true,
                  header: t("appBar.logoutDialog.header"),
                  body: t("appBar.logoutDialog.body"),
                  actionBtns: [
                    <SFButton
                      onClick={() => setDialog({ open: false })}
                      variant="transparent"
                    >
                      {t("appBar.logoutDialog.cancelBtn")}
                    </SFButton>,
                    <SFButton
                      onClick={() =>
                        baseContainer.authenticationService.logout()
                      }
                      variant="secondary"
                    >
                      {t("appBar.logoutDialog.okBtn")}
                    </SFButton>,
                  ],
                })
              }
            >
              <SFLogoutIcon color="white" size="small" />
            </SFIconButton>
          </SFStack>
        }
        disableGutters
        disablePadding
      >
        {props.notifications.length > 0 && (
          <SFNotifications
            notifications={props.notifications}
            onClickNotification={props.onClickNotification}
            onClose={props.onClose}
          />
        )}
        {props.notifications.length === 0 && (
          <StyledStack alignItems="center">
            <SFTypography variant="body1">
              {t("components.header.notificationPanel.noMessagesLabel")}
            </SFTypography>
          </StyledStack>
        )}
      </SFDrawer>
    </>
  );
};

SFNotificationPanel.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onClickNotification: PropTypes.func,
};

export default SFNotificationPanel;
